import { type ActorRefFromLogic, waitFor } from "xstate";

import { type PermRelation } from "~/state/types";
import { updatePublicAccess } from "~/utils/docsapi";

import { type AuthenticationMachine, authnStateNotUnknown } from "../authentication";

export const setRepoPublished = async ({
	input: { type, relation, workspaceName, documentId, authenticationActorRef, skip },
}: {
	input: {
		type: "grant" | "revoke";
		relation: PermRelation;
		workspaceName: string;
		documentId: string;
		authenticationActorRef: ActorRefFromLogic<AuthenticationMachine>;
		skip: boolean;
	};
}) => {
	if (skip) {
		return;
	}

	const authSnap = await waitFor(authenticationActorRef, authnStateNotUnknown);
	const token = await authSnap.context.getAccessTokenSilently();
	if (!token) {
		return;
	}
	await updatePublicAccess(token, type, workspaceName, documentId, relation);
};
